<template>
  <div>
    <TopMenu :leftOption="'back-dashboard'" :title="$t('Boxes')" />
    <div class="view">
      <transition name="fade" appear>
        <div>
          <div class="p-4">{{$t('Boxes')}}</div>
          <a v-for="box in getAllBoxes" @click="changeBox($event, box)" :key="box.uuid" class="d-block bg-dark px-4 py-3 text-muted" href="#">
            <FontAwesomeIcon icon="cube" class="text-primary mr-2"/> {{ box.name != null && box.name !== '' ? box.name : box.uuid }}
            <span class="float-right" :class="getStatusClass(box)">
              {{ getStatusText(box) }}
            </span>
          </a>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { ROUTE_DASHBOARD } from '@/const/routeNames'
import audioManager from '@/utils/audioManager'
import musicboxClient from '@/utils/musicboxClient'
import localStorageUtil from '@/utils/localStorageUtil'

export default {

  name: 'Boxes',

  data () {
    return {
      ROUTE_DASHBOARD
    }
  },

  computed: {
    getAllBoxes () {
      return this.$store.state.audio.allBoxes
    }
  },

  created () {
    this.refreshBoxes()
  },

  methods: {
    refreshBoxes () {
      musicboxClient.getBoxes()
        .then(res => {
          localStorageUtil.setAllBoxes(res.data)
          this.$store.commit('setAllBoxes', res.data)
        })
        .catch(() => {
          // Silently fail - show cached data
        })
    },

    changeBox (e, box) {
      e.preventDefault()
      audioManager.changeBox(box)
      this.$router.push(ROUTE_DASHBOARD)
    },

    getBoxStatus (box) {
      if (!box.last_seen) {
        return { online: false, lastSeen: null }
      }
      const lastSeenDate = new Date(box.last_seen)
      const secondsAgo = (Date.now() - lastSeenDate.getTime()) / 1000
      return { online: secondsAgo < 120, lastSeen: lastSeenDate, secondsAgo }
    },

    getStatusClass (box) {
      return this.getBoxStatus(box).online ? 'text-success' : 'text-danger'
    },

    getStatusText (box) {
      const status = this.getBoxStatus(box)
      if (status.online) return this.$t('Online')
      if (!status.lastSeen) return this.$t('Player offline')
      return this.formatLastSeen(status.secondsAgo)
    },

    formatLastSeen (secondsAgo) {
      const offline = this.$t('Player offline')
      if (secondsAgo < 3600) return offline + ' (' + Math.floor(secondsAgo / 60) + 'm)'
      if (secondsAgo < 86400) return offline + ' (' + Math.floor(secondsAgo / 3600) + 'h)'
      return offline + ' (' + Math.floor(secondsAgo / 86400) + 'd)'
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Boxes.vue